import React from 'react';
import { 
  Dumbbell, 
  Heart, 
  Scissors, 
  Mic, 
  Rocket, 
  Briefcase 
} from 'lucide-react';
import { audienceData } from '../data/mock';

const iconMap = {
  Dumbbell,
  Heart,
  Scissors,
  Mic,
  Rocket,
  Briefcase,
};

const AudienceSection = () => {
  return (
    <section className="section">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="inline-block text-sm font-semibold text-[#FF6B35] uppercase tracking-wider mb-4">
            Who It's For
          </span>
          <h2 className="heading-1 mb-4">
            Built for{' '}
            <span className="gradient-text">Winners</span>{' '}
            in Every Game
          </h2>
          <p className="body-large">
            Whether you're on the field, in the gym, behind the chair, or building your empire — 
            we've got you covered.
          </p>
        </div>
        
        <div className="flex flex-wrap justify-center gap-4">
          {audienceData.map((audience, index) => {
            const IconComponent = iconMap[audience.icon];
            return (
              <div 
                key={audience.id}
                className="audience-badge animate-fade-in-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <IconComponent size={20} className="text-[#FF6B35]" />
                <span>{audience.label}</span>
              </div>
            );
          })}
        </div>
        
        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mt-16">
          {[
            { value: '98%', label: 'Satisfaction Rate' },
            { value: '48hr', label: 'Avg. Turnaround' },
            { value: '100%', label: 'Custom Built' },
          ].map((stat, index) => (
            <div 
              key={index}
              className="text-center p-6 rounded-xl bg-[#12121A] border border-[#2A2A35] animate-fade-in-up"
              style={{ animationDelay: `${0.3 + index * 0.1}s` }}
            >
              <div className="text-3xl md:text-4xl font-bold gradient-text mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-[#6B6B78]">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AudienceSection;
